<template>
    <div>
        <form v-on:submit.prevent="onSubmit">
            <div class="d-block pt-5">
                <div class="row justify-content-center">
                    <div class="col-md-5">
                        <div class="d-block h2 font-bold mb-5"><i class="fa-solid fa-caret-right me-3 text-neon"></i>Masukan Data Siswa</div>
                        <div class="row">
                            <div class="col-8">
                                <div class="form-group">
                                    <label class="form-label">Nama Siswa<i
                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <v-select
                                        :disabled="form.id ? true:false"
                                        :options="dataStudent"
                                        label="fullname"
                                        v-model="form.users"
                                        placeholder="Pilih Siswa">
                                        <template #search="{attributes, events}">
                                            <input
                                            class="vs__search"
                                            :required="!form.users"
                                            v-bind="attributes"
                                            v-on="events"
                                            />
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group form-style-1">
                                    <label class="form-label">Kelas<i
                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control" disabled :value="form.users.class">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label">Tahun Lulus<i
                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input v-if="studentHasYear || !form.users" type="text" class="form-control" disabled :value="form.graduation_year" placeholder="-">
                                    <template v-else>
                                        <div class="form-select-wrapper form-select-style-1">
                                            <i class="fa-solid fa-caret-down"></i>
                                            <select class="form-select form-select-box-1" v-model="form.graduation_year" required oninvalid="this.setCustomValidity('Pilih Tahun Lulus')" oninput="this.setCustomValidity('')">
                                                <option value="">Pilih Tahun Lulus</option>
                                                <option v-for="(item, index) in dataYear" :key="index" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="small text-muted mt-2">
                                            Tahun lulus siswa belum diisi. Pilihan ini juga akan disimpan ke data siswa.
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label">Jalur Lulus<i
                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.graduation_path" required oninvalid="this.setCustomValidity('Pilih Jalur lulus')" oninput="this.setCustomValidity('')">
                                            <option value="">Pilih Jalur</option>
                                            <option v-for="(item, index) in dataGraduationPath" :key="index" :value="item">{{ item.toLocaleUpperCase()}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Konsultan<i
                                    class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                <div class="form-select-wrapper">
                                    <v-select
                                        :options="dataConsultant"
                                        label="fullname"
                                        v-model="form.consultant"
                                        placeholder="Pilih Konsultan">
                                        <template #search="{attributes, events}">
                                            <input
                                            class="vs__search"                                            
                                            v-bind="attributes"
                                            v-on="events"
                                            />
                                        </template>
                                    </v-select>
                                </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Pilihan Universitas 1<i
                                    class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                            <v-select
                                :disabled="$parent.dataRationalization.users.allow_change_major != 1 ? true:false"
                                :options="dataUniversity"
                                label="name"
                                v-model="form.university_one"
                                placeholder="Pilih Universitas 1"
                                @input="getMajorOne()">
                                <template #search="{attributes, events}">
                                    <input
                                    class="vs__search"
                                    :required="!form.university_one"
                                    v-bind="attributes"
                                    v-on="events"
                                    />
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Pilihan Jurusan 1<i
                                    class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                            <v-select
                                :disabled="$parent.dataRationalization.users.allow_change_major != 1 ? true:false"
                                :options="dataMajorOne"
                                label="major_fullname"
                                v-model="form.major_one"
                                placeholder="Pilih Jurusan 1">
                                <template #search="{attributes, events}">
                                    <input
                                    class="vs__search"
                                    :required="!form.major_one"
                                    v-bind="attributes"
                                    v-on="events"
                                    />
                                </template>
                            </v-select>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Pilihan Universitas 2<i
                                    class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                            <v-select
                                :disabled="$parent.dataRationalization.users.allow_change_major != 1 ? true:false"
                                :options="dataUniversity"
                                label="name"
                                v-model="form.university_two"
                                placeholder="Pilih Universitas 1"
                                @input="getMajorTwo()">
                                <template #search="{attributes, events}">
                                    <input
                                    class="vs__search"
                                    :required="!form.university_two"
                                    v-bind="attributes"
                                    v-on="events"
                                    />
                                </template>
                            </v-select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Pilihan Jurusan 2<i
                                    class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                            <v-select
                                :disabled="$parent.dataRationalization.users.allow_change_major != 1 ? true:false"
                                :options="dataMajorTwo"
                                label="major_fullname"
                                v-model="form.major_two"
                                placeholder="Pilih Jurusan 2">
                                <template #search="{attributes, events}">
                                    <input
                                    class="vs__search"
                                    :required="!form.major_two"
                                    v-bind="attributes"
                                    v-on="events"
                                    />
                                </template>
                            </v-select>
                        </div>

                        
                        <div v-if="form.users.account_type == 'free'" class="d-none pt-4 text-muted small border-top mt-4 mb-4 text-center">
                            {{ form.users.fullname }} <b>hanya dapat memilih jurusan 1x</b> karena terdaftar sebagai akun gratis.
                        </div>

                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end mt-4 pt-4 border-top mb-5">
                <button type="submit" class="btn btn-primary btn-lg btn-s-1">
                    <div class="btn-s-1-inner">Selanjutnya<i class="fa-solid fa-arrow-right fa-lg ms-3"></i></div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
    name: 'RationalizationFormBiodata',
    data() {
        return {
            emptyState          : false,
            dataFetch           : false,
            dataStudent         : [],
            dataConsultant      : [],
            dataYear            : [],
            dataUniversity      : [],
            dataMajorOne        : [],
            dataMajorTwo        : [],
            dataGraduationPath  : [
                'belum',
                'snbp',
                'snbt'
            ],
            form : {
                id    : '',
                code  : '',
                users : '',
                consultant : '',
                university_one : '',
                major_one : '',
                university_two : '',
                major_two : '',
                graduation_year : '',
                graduation_path : '',
            }
        }
    },
    validations: {
        form: {
            users: {
                required
            },
            university_one: {
                required
            },
            major_one: {
                required
            },
            university_two: {
                required
            },
            major_two: {
                required
            },
            graduation_year: {
                required
            },
            graduation_path: {
                required
            }
        }
    },    
    computed: {
        // Siswa yang sudah punya tahun lulus: terkunci. Belum punya: bisa dipilih di sini.
        studentHasYear: function() {
            return !!(this.form.users && this.form.users.graduation_year);
        }
    },
    watch: {
        'form.users': function() {
            if(this.studentHasYear) {
                this.form.graduation_year = this.form.users.graduation_year;
            } else if(!this.form.id) {
                this.form.graduation_year = '';
            }
        }
    },
    created() {
        this.getYear();
        this.getUsers();
        this.getUniversity();
        this.checkData();
    },
    methods: {
        getYear: function() {
            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataYear = res.data.data;
            });
        },
        checkData: function() {
            if ((this.$parent.dataRationalization.id !== undefined) && (this.$parent.dataRationalization.id !== null) && (this.$parent.dataRationalization.id !== "")) {            
                let datasets = this.$parent.dataRationalization;
                for (let key in datasets) {
                    if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                        let value = datasets[key];

                        // Draft dari import nilai belum punya kampus/jurusan (datang sebagai []).
                        if(['university_one', 'university_two', 'major_one', 'major_two'].includes(key) && Array.isArray(value) && value.length === 0) {
                            value = '';
                        }

                        this.form[key] = value;

                        if(key == 'university_one' && value) {
                            this.getMajorOne();
                        }
                        if(key == 'university_two' && value) {
                            this.getMajorTwo();
                        }
                    }
                }

                // Data siswa menang; kalau kosong, pakai tahun lulus rasionalisasi yang tersimpan.
                if(this.studentHasYear) {
                    this.form.graduation_year = this.form.users.graduation_year;
                } else if(this.form.graduation_year) {
                    this.form.graduation_year = parseInt(this.form.graduation_year, 10);
                }
            }
        },
        getUsers: function() {
            let uri         = process.env.VUE_APP_APIHOST+'users/list-by-school';

            this.dataFetch  = true;                
            this.$http.get(uri, {
                params : {
                    id : this.form.id
                }
            }).then(res => {
                this.dataFetch  = false;
                this.dataStudent     = res.data.student;
                this.dataConsultant  = res.data.consultant;
            });
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list-by-pg-major';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajorOne: function() {
            this.form.major_one = "";
            let uri         = process.env.VUE_APP_APIHOST+'major/list-by-school';
            this.$http.get(uri , {
                params : {
                    university_id : this.form.university_one.id
                }
            }).then(res => {
                this.dataMajorOne  = res.data.data;
            });
        },
        getMajorTwo: function() {
            this.form.major_two = "";
            let uri         = process.env.VUE_APP_APIHOST+'major/list-by-school';
            this.$http.get(uri , {
                params : {
                    university_id : this.form.university_two.id
                }
            }).then(res => {
                this.dataMajorTwo  = res.data.data;
            });
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();

                for (let key in this.form) {
                    if(key == 'users') {
                        formData.append('users', JSON.stringify(this.form.users));
                    }
                    else if(key == 'consultant') {
                        formData.append('consultant', JSON.stringify(this.form.consultant));
                    }
                    else if(key == 'university_one') {
                        formData.append('university_one', JSON.stringify(this.form.university_one));
                    }
                    else if(key == 'university_two') {
                        formData.append('university_two', JSON.stringify(this.form.university_two));
                    }
                    else if(key == 'major_one') {
                        formData.append('major_one', JSON.stringify(this.form.major_one));
                    }
                    else if(key == 'major_two') {
                        formData.append('major_two', JSON.stringify(this.form.major_two));
                    }
                    else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            // Backend juga menyimpan tahun lulus ke data siswa, jadi kunci di sini.
                            if(this.form.users && !this.studentHasYear) {
                                this.$set(this.form.users, 'graduation_year', this.form.graduation_year);
                            }

                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    // Pindah ke halaman edit hanya kalau belum di sana.
                                    if(this.$route.params.code !== response.data.code) {
                                        this.$router.push({
                                            name : 'rationalization_form_edit',
                                            params: { code: response.data.code }
                                        });
                                    }
                                    this.$parent.getDataByCode(response.data.code);
                                    this.$parent.getStep();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });
            }
        }
    }
}
</script>